import React from 'react';

const AnimatedGradient = () => (
  <linearGradient id="sparkle-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
    <stop offset="0%" stopColor="#7c3aed">
      <animate attributeName="offset" values="0;1;0" dur="3s" repeatCount="indefinite" />
    </stop>
    <stop offset="50%" stopColor="#f43f5e">
      <animate attributeName="offset" values="0.5;0;0.5;1;0.5" dur="3s" repeatCount="indefinite" />
    </stop>
    <stop offset="100%" stopColor="#f59e42">
      <animate attributeName="offset" values="1;0;1" dur="3s" repeatCount="indefinite" />
    </stop>
  </linearGradient>
);

const SparkleIcon = ({ gradient = false, className = '', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 125"
    x="0px"
    y="0px"
    className={className}
    {...props}
  >
    {gradient && (
      <defs>
        <AnimatedGradient />
      </defs>
    )}
    <path fill={gradient ? 'url(#sparkle-gradient)' : 'currentColor'} d="m6.67,63.16l9.9,3.34c5.02,1.7,8.97,5.64,10.66,10.66l3.34,9.9c.61,1.8,3.15,1.8,3.76,0l3.34-9.9c1.7-5.02,5.64-8.97,10.66-10.66l9.9-3.34c1.8-.61,1.8-3.15,0-3.76l-9.9-3.34c-5.02-1.7-8.97-5.64-10.66-10.66l-3.34-9.9c-.61-1.8-3.15-1.8-3.76,0l-3.34,9.9c-1.7,5.02-5.64,8.97-10.66,10.66l-9.9,3.34c-1.8.61-1.8,3.15,0,3.76Z"/>
    <path fill={gradient ? 'url(#sparkle-gradient)' : 'currentColor'} d="m79.55,29.4c-.46-1.35-2.36-1.35-2.82,0l-2.3,6.81c-.8,2.36-2.65,4.22-5.02,5.02l-6.81,2.3c-1.35.46-1.35,2.36,0,2.82l6.81,2.3c2.36.8,4.22,2.65,5.02,5.02l2.3,6.81c.46,1.35,2.36,1.35,2.82,0l2.3-6.81c.8-2.36,2.65-4.22,5.02-5.02l6.81-2.3c1.35-.46,1.35-2.36,0-2.82l-6.81-2.3c-2.36-.8-4.22-2.65-5.02-5.02l-2.3-6.81Z"/>
    <path fill={gradient ? 'url(#sparkle-gradient)' : 'currentColor'} d="m63.39,21.44l-4.99-1.69c-1.18-.4-2.11-1.33-2.51-2.51l-1.69-4.99c-.3-.9-1.58-.9-1.88,0l-1.69,4.99c-.4,1.18-1.33,2.11-2.51,2.51l-4.99,1.69c-.9.3-.9,1.58,0,1.88l4.99,1.69c1.18.4,2.11,1.33,2.51,2.51l1.69,4.99c.3.9,1.58.9,1.88,0l1.69-4.99c.4-1.18,1.33-2.11,2.51-2.51l4.99-1.69c.9-.3.9-1.58,0-1.88Z"/>
  </svg>
);

export default SparkleIcon; 